<template>
  <div class="rp-messenger-order-summary animated fast fadeInLeft">
    <OrderItem
      v-if="order"
      class="rp-messenger-order-head-card"
      :orderData="order"
      :showTopHeaderOnly="true"
      :actionsList="[]"
    />
    <div class="rp-messenger-order-scenario-content__wrapper">
      <template v-if="isExternalHelpdesk && formSubmitted">
          <ExternalHelpdesk
              :status="submittingPrechatFormData"
              @go-home="$emit('switchToHomeScreen', {})"
            />
        </template>
        <template>
          <div class="rp-scenario-desc__wrapper" v-if="!moveToItemSelectionOrPrechatScreen">
        <div class="order-delivery-summery-header">
          <ScenarioBackButton />
          <span class="order-header-text">{{ scenarioName }}</span>
          <div
            class="order-response-text"
            v-if="formattedScenarioDesc"
            v-html="formattedScenarioDesc"
            v-linkified
          ></div>
        </div>
        <div
          class="rp-scenario-buttons"
          v-for="(ctaButton, index) in ctaList"
          :key="index"
        >
          <el-button
            :style="{color: activeColor, borderColor: activeColor}"
            @click="handleCtaClick(ctaButton.buttonUrl)"
            plain
            class="uppercase-text"
          >
            <span class="scenario-button-text">{{ctaButton.buttonText}}</span>
          </el-button>
        </div>
        <div class="rp-scenario-button-suggestion-text" v-if="defaultActionType === 'ASK_FOR_RATING'" > {{$t('customerJourneyPreChatForm.canWeHelpWithAnythingElse')}} </div>
        <div class="rp-scenario-buttons default-ctas" :class="{ 'ask-for-rating' : defaultActionType === 'ASK_FOR_RATING' }">
          <el-button
            :style="{color: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#4d4d4d', borderColor: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#DCDFE6', background: defaultActionType === 'ASK_FOR_RATING' ? '#ededed': 'inherit'}"
            @click="handleMovingToNextScreen(defaultActionData.primaryCTAConfig.action)"
            plain
            class="uppercase-text"
          >
            <span class="scenario-button-text">{{defaultActionData.primaryCTAConfig.title}}</span>
          </el-button>
           <el-button
                v-if="defaultActionType === 'ASK_FOR_RATING'"
                :style="{color: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#4d4d4d', borderColor: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#DCDFE6', background: defaultActionType === 'ASK_FOR_RATING' ? '#ededed': 'inherit'}"
                 @click="handleMovingToNextScreen(defaultActionData.secondaryCTAConfig.action)"
                plain
                class="uppercase-text"
              >
                <span class="scenario-button-text">{{defaultActionData.secondaryCTAConfig.title}}</span>
              </el-button>
          <el-button
            v-else
            @click="handleMovingToNextScreen(defaultActionData.secondaryCTAConfig.action)"
            type="text"
            class="rp-scneario-text-button"
          >
            <span class="scenario-button-text">{{defaultActionData.secondaryCTAConfig.title}}</span>
          </el-button>
        </div>
      </div>
      <div class="rp-scenario-desc__wrapper" v-else>
        <div class="order-delivery-summery-header">
          <ScenarioBackButton />
          <span class="order-header-text">{{ scenarioName }}</span>
        </div>
        <div class="order-delivery-summery-header no-margin">
          <div class="order-sub-header">
            <span class="order-sub-header__title">{{$t('orderList.selectRelevantItems')}}</span>
            <el-checkbox
              :indeterminate="isIndeterminate"
              size="medium"
              class="checkbox-custom-circle"
              @change="handleItemCheckboxClick"
              v-model="checkAll"
            >{{$t('orderList.selectAll')}}</el-checkbox>
          </div>
        </div>
        <div class="order-delivery-details">
          <el-checkbox-group 
            v-model="checkedProducts" 
            class="order-product-content"
            @change="handleItemCheckboxClick"
          >
            <el-checkbox
              class="checkbox-custom-circle checkbox-item-selection"
              :label="product.id+':'+product.productId"
              v-for="product in productsList"
              :key="product.id+':'+product.productId"
            >
              <div class="order-products" v-on:click.stop.prevent="stopPropagation">
                <Inline
                  :justify="'space-beween'"
                  :type="'flex-start'"
                  :style="{justifyContent: 'space-between'}"
                >
                  <Inline :type="'flex-start'">
                    <div>
                      <img
                        v-if="getImageUrl(product)"
                        :src="getImageUrl(product)"
                        height="40"
                        width="40"
                      />
                      <img v-else src="@/assets/img/No-Image.jpg" height="40" width="40" />
                    </div>
                    <HMargin :unit="0.5" />
                    <div>
                      <div class="order-product-name">{{product.name}}</div>
                      <div
                        class="order-product__items-and-price"
                      >{{`${currencySymbol}${product.price}`}} X {{product.quantity}}</div>
                    </div>
                    <HMargin :unit="0.5" />
                  </Inline>
                  <Inline>
                    <div>{{ currencySymbol }}{{ (product.price * product.quantity).toFixed(2) }}</div>
                  </Inline>
                </Inline>

                <div class="item-count" v-if="checkedProducts.includes(product.id+':'+product.productId)">
                  <div>{{$t('orderList.selectQuantity')}}</div>
                  <el-input-number
                    class="rp-input-number"
                    size="small"
                    v-model="quantities[product.id+':'+product.productId]"
                    :min="1"
                    :max="product.quantity"
                  ></el-input-number>
                </div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
          <div class="rp-error-msg" v-if="showErrorMessage">{{getErrorMessage}}</div>
        </div>
        <div class="prechatform-wrapper" v-if="isPreChatFormOpen">
          <PreChatForm
            @submit="handlePreChatAndProceedClick"
            @updateErrorMessage="updateErrorMessage"
            :showAllDataTypes="true"
            :formHeaderLabel="$t('customerJourneyPreChatForm.heading')"
            class="animated fast fadeInRight"
            :formConfiguration="formConfiguration"
            :submitButtonlabel="proceedButtonLabel"
            :disableProceed="disableProceed"
            :userProperties="userProperties"
			      :popoverWidth="332"
          />
        </div>
        <div class="rp-scenario-buttons" v-else>
          <el-button
            :style="{ color:activeColor, borderColor:activeColor }"
            :class="{'rp-form-error': isError}"
            @click="handleOrderStartChatClick(null)"
            class="proceed-btn"
          >{{ proceedButtonText }}</el-button>
        </div>
      </div>
        </template>
    </div>
  </div>
</template>

<script>
//import reorderButton from "./reorderButton";
import Vue from "vue";
import PreChatForm from "./../../TextMessage/PreChatForm";
import { parsePropertyTagsV2, formattedOrderDataV2, formatTheValue } from "./../../../constants";
import ExternalHelpdesk from './../../ExternalHelpdesk';
import defaultActinMixin from './../HelpAndSupport/defaultActionMixin'
export default {
  mixins: [
    defaultActinMixin
  ],
  name: "OrderSummary",
  components: {
    PreChatForm,
    ExternalHelpdesk
  },
  props: {
    order: Object,
    scenarioName: String,
    activeColor: String,
    responseText: String,
    properties: Object,
    customerProperties: Object,
    canSelectItems: {
      type: Boolean,
      required: true
    },
    ctaList: {
      type: Array
    },
    isCollectUserInputEnabled: {
      type: Boolean,
      required: true
    },
    chatUserInputs: {
      type: Array,
      required: true
    },
    proceedButtonLabel: {
      type: String,
      default: "Proceed"
    },
    defaultActionType: {
      type: String,
      default: 'CONTACT_SUPPORT'
    },
    isExternalHelpdesk: {
      type: Boolean,
      default: false,
    },
    submittingPrechatFormData: {
      type: String,
      default: "Loading",
    },
  },

  data() {
    return {
      checkedProducts: [],
      quantities: {},
      moveToItemSelectionOrPrechatScreen: false,
      proceedButtonText: this.proceedButtonLabel,
      isError: false,
      showErrorMessage: false,
      formSubmitted: false,
    };
  },
  mounted() {
    this.autoFillTheMaximumQuantity();
    this.$emit('scenarioEvent', { status: 1 })
  },
  methods: {
    updateErrorMessage(bool) {
      this.showErrorMessage = bool;
    },
    handleItemCheckboxClick(val) {
      this.showErrorMessage = false;
    },
    getImageUrl(product) {
      if (!product) return "";
      const { imageURL } = product;
      if (imageURL instanceof Array && imageURL.length > 0) {
        return imageURL[0];
      }
      return "";
    },
    showAlertOnFormCTA (message = this.proceedButtonLabel) {
      this.isError = true;
      this.showErrorMessage = true;
      this.updateProceedButtonText(message)
      setTimeout(() => {
        this.isError = false
        this.resetProceedButtonText()
      }, 2500)
    },
    resetProceedButtonText () {
      this.proceedButtonText = this.proceedButtonLabel
    },
    updateProceedButtonText(message) {
        this.proceedButtonText = message
    },
    handleCtaClick(url) {
      window.open(url, "_blank");
      this.$emit('scenarioEvent', { status: 2 })
    },
    autoFillTheMaximumQuantity() {
      for (let product of this.productsList) {
        let productId = product.id+':'+product.productId;
        Vue.set(this.quantities, productId, product.quantity);
      }
    },
    stopPropagation(e) {},

    checkAllProductsOfOrder(checkOrUncheck) {
      this.checkedProducts = [];
      for (let product of this.productsList) {
        let productId = product.id+':'+product.productId;
        if (!this.checkedProducts.includes(productId))
          this.checkedProducts.push(productId);
      }
      this.autoFillTheMaximumQuantity();
    },
    async handleMovingToNextScreen(action) {
      if(action === 'ATTEMPT_TO_CLOSE') {
        this.$emit('scenarioEvent', { status: 2 })
        this.$emit('switchToHomeScreen', {})
        return;
      }
      if(action === 'ASK_FOR_RATING') {
        //go to 3rd screen level breadcrumb if order scenario
        this.$emit('scenarioEvent', { status: 2 })
        this.$emit('moveToScenario', { scenarioId: 'HELP_AND_SUPPORT_ORDER' })
        return
      }
      if(action === 'ASK_FOR_RATING_NO') {
        //go to 1st screen level breadcrumb
        //clsoe the messenger
        this.$emit('scenarioEvent', { status: 4 })
        this.$emit('switchToHomeScreen', { closeMessenger: true })
        return
      }
      if (this.canSelectItems || this.isExternalHelpdesk) {
        this.moveToItemSelectionOrPrechatScreen = true;
      } else {
        await this.handleOrderStartChatClick(null);
      }
    },
    async handleOrderStartChatClick(event) {
      if(this.disableProceed) {
        this.showAlertOnFormCTA(this.$t('orderList.selectItemsErrorMsg'))
        return ;
      }
      if(!this.isExternalHelpdesk){
        await this.$emit("orderConversation", {
          selectedProucts: this.checkedProducts,
          quantities: this.quantities,
          orderInfo: this.order,
          prechatFormData: event,
        });
      };
      this.$emit('scenarioEvent', { status: 3 })
    },
    async handlePreChatAndProceedClick(event) {
      if(!this.isExternalHelpdesk){
        await this.handleOrderStartChatClick(event);
      } else {
          event.order = formattedOrderDataV2({
          selectedProucts: this.checkedProducts,
          quantities: this.quantities,
          orderInfo: this.order
        })
        this.$emit("handleScenarioPreChatFormSubmit", event);
      }
      this.formSubmitted = true;
      this.$emit('scenarioEvent', { status: 3 })
    }
  },

  computed: {
    
    getErrorMessage() {
      if(this.showErrorMessage) {
        return this.$t('orderList.selectItemsErrorMsg')
      }
      return "";
    },
    currencySymbol() {
      return this.$root.configuration.currency.symbol;
    },
    disableProceed() {
      return this.checkedProductsLength < 1;
    },
    checkedProductsLength() {
      return this.checkedProducts.length;
    },
    userProperties() {
      const { properties, customerProperties } = this;
      return { ...properties, ...customerProperties };
    },
    formattedScenarioDesc() {
      return parsePropertyTagsV2(this.responseText, (propName, type, propertyCategory) => {
        const { userProperties, order } = this;
          let propertiesDB = userProperties;
          if(propertyCategory === 'order'){
            propertiesDB = order
          }
          if (propertiesDB) {
            if (propName in propertiesDB) {
              return formatTheValue(propertiesDB[propName], type);
            }
          }
          return ''
      });
    },
    isIndeterminate() {
      return this.checkedProductsLength &&
        this.checkedProductsLength !== this.productsList.length
        ? true
        : false;
    },
    isPreChatFormOpen() {
      return (this.isCollectUserInputEnabled && this.chatUserInputs.length > 0) || this.isExternalHelpdesk;
    },
    formConfiguration() {
      const conf = {
        formType: "customerJourney",
        fields: []
      };
      if (this.isCollectUserInputEnabled) {
        if (!this.chatUserInputs || !this.chatUserInputs.length > 0)
          return conf;
        const { chatUserInputs } = this;
        chatUserInputs.forEach(inputField => {
          inputField.value = "";
          conf.fields.push(inputField);
        });
      }
      if(this.isExternalHelpdesk){
        if(!this.userProperties.email) {
          if(!conf.fields.find(({ propertyName }) => propertyName === 'email' )){
            conf.fields.push({
              groupName: 'People Data',
              propertyName: 'email',
              displayName: 'Email',
              type: "text",
              required: true,
              value: '',
            })
          }
        }
        conf.fields.push({
          groupName: 'Conversation Data',
          propertyName: 'customerMessageForExternalHelpdesk',
          displayName: 'Your message',
          type: "multiline",
          required: true,
          value: '',
          placeholder: false,
        })
      }
      return conf;
    },
    checkAll: {
      get() {
        return this.checkedProductsLength === this.productsList.length;
      },
      set() {
        if (this.checkedProductsLength === 0)
          this.checkAllProductsOfOrder(true);
        else {
          this.checkedProducts = [];
          this.quantities = {};
        }
      }
    },

    productsList() {
      return this.order && this.order.products ? this.order.products : [];
    }
  }
};
</script>
<style lang="scss">
.rp-messenger-order-summary {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--theme-color) !important;
  }
  .el-checkbox__inner:hover,
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: var(--theme-color) !important;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
  }
  $borderColor: #cccccc;
  .checkbox-custom-circle {
    .el-checkbox__inner {
      border-radius: 20px !important;
      height: 18px;
      width: 18px;
      border: 1px solid #cccccc;
    }
    .el-checkbox__inner::after {
      height: 9px;
      width: 5px;
    }
    .el-checkbox__inner::after {
      border: 2px solid #cccccc;
      border-left: 0;
      border-top: 0;
      transform: rotate(45deg) scaleY(1);
    }
    .is-checked {
      .el-checkbox__inner::after {
        border: 2px solid #ffffff;
        border-left: 0;
        border-top: 0;
      }
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
      top: 7px;
    }
    .el-checkbox__label{
      @include for-size(desktop-up){
        font-size: 18px;
        line-height: 1.4
      }
    }
    .el-checkbox__input {
      @include for-size(desktop-up){
        margin-bottom: 2px;
      }
    }
  }
  .checkbox-item-selection {
    border-bottom: 1px solid #cccccc;
    padding-top: 0.7rem;
    .el-checkbox__label {
      width: 90%;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: inherit !important;
    }
  }

  .btn-custom-circle {
    .el-button.is-circle {
      border-radius: 50%;
      padding: 12px;
    }
  }
  .rp-input-number {
    width: 95px !important;
    input {
      border: 0px;
      padding-left: 30px !important;
      padding-right: 30px !important;
      height: 25px !important;
      line-height: 25px !important;
      color: #4d4d4d;
      font-weight: 400;
      font-size: 17px;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 25px !important;
      height: 25px !important;
      border-radius: 50%;
      border: 1px solid #cccccc;
      background: #fff;
      line-height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: #111111;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
$borderColor: #cccccc;
.no-margin {
  margin: 0 !important;
}

.rp-messenger-order-summary {
  margin: 16px;
  width: calc(100% - 32px);
  border-radius: 5px;
  background: #fff;
  height: unset;
  box-shadow: 0 1px 0 #fff, 0 1px 5px rgba(0, 0, 0, 0.35);

  .rp-messenger-order-scenario-content__wrapper {
    padding: 20px;
    @include for-size(desktop-up){
      padding: 30px 60px;
    }
    @include for-size(tablet-landscape-up) {
      padding: 30px 60px;
    }
  }
  .delivery-address-footer {
    color: #4d4d4d;
    font-size: 12px;
    display: flex;
    justify-content: center;
    border-top: 1px solid $borderColor;
    font-weight: bold;
    padding: 10px;
    cursor: pointer;
  }

    .order-delivery-summery-header {
      display: flex;
      flex-direction: column;
	    margin-bottom: 12px;
      // padding: 20px 20px 20px 20px;
       @include for-size(tablet-landscape-up){
        width: 500px;
        max-width: 100%;
        margin: 0 auto !important;;
      }
      @include for-size(desktop-up){
        width: 640px;
        max-width: 100%;
        margin: 0 auto !important;
      }

    .order-header-text {
      font-size: 24px;
      color: #333333;
      font-weight: 500;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      @include for-size(desktop-up){ 
        font-size: 28px;
      }
    }
    .order-response-text {
    }

    .order-sub-header {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      line-height: 22px;
      font-size: 15px;
      @include for-size(desktop-up){
        font-size: 19px;
      }
      margin-top: 0.5rem;
      color: #333333;
      padding-bottom: 1rem;
      border-bottom: 1px solid $borderColor;
      font-weight: 400;

      .order-sub-header__title {
        font-weight: 500;
      }
    }

    .rp-messenger-order-status {
      text-align: center;
    }

    .btn.rp-order-status {
      padding: 0.45rem 1rem;
      font-size: 11px;
      margin-top: 14px;
      letter-spacing: 1px;
      word-spacing: 1px;
      display: flex;
      font-weight: 600;
      align-items: center;
      justify-content: center;
      color: #4d4d4d;
      border: 1px solid #4d4d4d;
      background-color: rgb(255, 255, 255);
    }
  }
	.rp-scenario-desc__wrapper {
		padding: 0px;

      .rp-scenario-buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 12px 0px 0px 0px;
        max-width: 360px;
        &.default-ctas {
          margin-top: 2rem;
        }
        &.ask-for-rating {
          margin-top: 0rem;
          flex-direction: row;
          .el-button + .el-button {
            margin-left: 20px;
          }
        }
        @include for-size(tablet-landscape-up){
          width: 360px;
          max-width: 100%;
          margin: 0 auto;
        }
        @include for-size(desktop-up){
          width: 360px;
          max-width: 100%;
          margin: 0 auto;
        }

      button {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        line-height: 22px;
        @include for-size(desktop-up){
          font-size: 16px;
        }
      }
    }
    .rp-scenario-content-ctaButtons {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 12px 0px 0px 0px;

      button {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        line-height: 22px;
      }
    }
	}

  .order-delivery-details {
    padding: 0px 0px 20px 0px;
    letter-spacing: 0.3px;
    color: #4d4d4d;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    @include for-size(tablet-landscape-up){
      width: 500px;
      max-width: 100%;
      margin: 0 auto;
    }
    @include for-size(desktop-up){
      width: 640px;
      max-width: 100%;
      margin: 0 auto;
    }

    .order-product-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // border-bottom: 1px solid $borderColor;
      label {
        width: 100%;
        align-items: flex-start;
        display: flex;
        justify-content: space-between;

        .el-checkbox__input {
          vertical-align: top;
        }
      }

      .order-products {
        display: flex;
        flex-direction: column;
        padding-bottom: 0.7rem;
        img {
          @include for-size(tablet-landscape-up){
            width: 60px;
            height: 60px;
          }
          @include for-size(desktop-up){
            height: 80px;
            width: 80px;
          }
        }

        .order-product-image {
          font-size: 27px;
        }
      }

      .order-product-name {
        max-width: 100%;
        white-space: pre-wrap;
        color: #4d4d4d;
      }

      .item-count {
        display: flex;
        border-top: 1px solid#f2f2f2;
        margin-top: 0.5rem;
        justify-content: space-between;
        align-items: center;
        padding: 0.7rem 0rem 0rem 0rem;
      }
    }

    .checkbox {
      .el-checkbox__inner {
        border-radius: 20px !important;
      }
    }
    .total {
      display: flex;
      justify-content: flex-end;
      padding-top: 15px;
      padding-bottom: 20px;
    }

    .order-delivery-location-brand-name {
      // line-height: 35px;
      padding-top: 15px;
      // padding-bottom: 10px;
      font-size: 12px;
      letter-spacing: 0.3px;
      color: #666666;
      font-weight: 500;
    }
  }

  //   .prechatform-wrapper {
  // 	padding: 20px;
  //   }

  .order-proceed-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 12px 0px 0px 0px;
}
}
</style>

<style lang="scss" scoped>

.rp-form-error {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  background-color: #ff0000 !important;
  border-color:  #ff0000 !important;
  color: #fff !important;
  opacity: 0.8 !important;
  font-size: 14px;
  transition: 0.3s opacity ease-in;
  .text {
	//   animation: text-appear 0.5s
	// transition: 0.3s opacity ease-in;
	// transform: scaleY(1) translateZ(0);
	// transform-origin: 50% 50%;
  }
  &:hover,
  &:focus {
    background-color: #ff0000 !important;
    border-color:  #ff0000 !important;
    color: #fff !important;
  }
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

@keyframes text-appear {
//   0%, 12.66%, 100% {transform:translate3d(0,0,0);}
//   16.66%, 29.32% {transform:translate3d(0,-25%,0);}
//   33.32%,45.98% {transform:translate3d(0,-50%,0);}
//   49.98%,62.64% {transform:translate3d(0,-75%,0);}
//   66.64%,79.3% {transform:translate3d(0,-50%,0);}
//   83.3%,95.96% {transform:translate3d(0,-25%,0);}
	0% {
		transform: translateX(0);
		opacity: 0;
	}
	50% {
		transform: translateX(1.5);
	}
	100% {
		transform: translateX(1);
	}
}
.rp-error-msg {
  font-size: 11.5px;
  font-weight: 400;
  margin-top: 4px;
  /* padding: 0 15px; */
  // text-transform: capitalize;
  color: #fd5f75;
  font-style: italic;
}
</style>